<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">POI Name</label>
          <v-select
            :options="PoiList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.poi_id"
            @search="searchPoi"
            class="mb-3 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 1200 : 93"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column prop="imei" label="Imei" sortable> </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable>
          </el-table-column>
          <el-table-column prop="device_name" label="Device Name" sortable>
          </el-table-column>
          <el-table-column prop="poi_name" label="POI Name" sortable>
          </el-table-column>
          <el-table-column prop="ingpstime" label="Enter POI" sortable>
          </el-table-column>
          <el-table-column prop="gpstime" label="Out POI" sortable>
          </el-table-column>
          <el-table-column prop="totaltime" label="Total Time" sortable>
          </el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      filter: {
        poi_id: ''
      },

      filtered: {
        poi_id: ''
      },

      PoiList: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',

      sort_by:
        ({ prop: 'imei', order: 'descending' },
        { prop: 'plate', order: 'descending' },
        { prop: 'device_name', order: 'descending' },
        { prop: 'poi_name', order: 'descending' },
        { prop: 'ingpstime', order: 'descending' },
        { prop: 'totaltime', order: 'descending' },
        { prop: 'gpstime', order: 'descending' }),

      filename: 'Vehicle On POI Report',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchPoi('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchPoi(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataPoi(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataPoi(keyword)
        } else {
          this.PoiList = []
        }
      }
    },

    getDataPoi(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.$http
          .get(`${this.$api.endpoint}/poi/datatable`, {
            params: {
              page: 1,
              per_page: 50,
              search: keyword
            },

            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.PoiList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }, 1000)
    },

    initTable() {
      this.loading = true
      this.data = []

      this.$http
        .get(`${this.$api.endpoint}/vehicle_on_poi/datatable`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            poi_id: this.filter.poi_id ? this.filter.poi_id.value : '-'
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = index + 1
          })
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.poi_id = this.filter.poi_id

      this.page = 1
      this.initTable()
    },

    exportReport() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      let imei = []
      this.filtered.device.map((item) => [imei.push(parseInt(item.value))])

      this.$http
        .get(`${this.$api.endpoint}/report/export_mileage_report`, {
          responseType: 'blob',
          params: {
            imei: imei.length > 0 ? JSON.stringify(imei) : '',
            start: `${this.filtered.start_time}:00`,
            end: `${this.filtered.end_time}:00`,
            used_fuel: this.filtered.used_fuel
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `POI_Summary_Report_${this.filtered.start_time
            .toString()
            .substr(0, 10)}_${this.filtered.end_time
            .toString()
            .substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Imei',
          'Plate',
          'Device Name',
          'POI Name',
          'Enter POI',
          'Out POI',
          'Total Time'
        ]
        const filterVal = [
          'no',
          'imei',
          'plate',
          'device_name',
          'poi_name',
          'ingpstime',
          'gpstime',
          'totaltime'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>
